package link.erpango.quip.data

import kotlinx.browser.window
import link.erpango.quip.domain.entities.DAuth

/**
 * Persists auth session data in browser localStorage so that
 * it survives page reloads (the SQLite DB is in-memory on JS).
 */
object JsSessionStorage {

    private const val KEY_USER = "quip_session_user"
    private const val KEY_ACCESS = "quip_session_access"
    private const val KEY_REFRESH = "quip_session_refresh"
    private const val KEY_CREATED_AT = "quip_session_created_at"

    fun saveSession(auth: DAuth) {
        try {
            val storage = window.localStorage
            auth.user?.let { storage.setItem(KEY_USER, it) }
            auth.access?.let { storage.setItem(KEY_ACCESS, it) }
            auth.refresh?.let { storage.setItem(KEY_REFRESH, it) }
            auth.createdAt?.let { storage.setItem(KEY_CREATED_AT, it.toString()) }
            println("JsSessionStorage: Session saved for user ${auth.user}")
        } catch (e: Exception) {
            println("JsSessionStorage: Failed to save session: ${e.message}")
        }
    }

    fun getSession(): DAuth? {
        return try {
            val storage = window.localStorage
            val user = storage.getItem(KEY_USER) ?: return null
            val access = storage.getItem(KEY_ACCESS) ?: return null
            val refresh = storage.getItem(KEY_REFRESH) ?: ""
            val createdAt = storage.getItem(KEY_CREATED_AT)?.toLongOrNull()

            println("JsSessionStorage: Restored session for user $user")
            DAuth(
                user = user,
                access = access,
                refresh = refresh,
                createdAt = createdAt
            )
        } catch (e: Exception) {
            println("JsSessionStorage: Failed to read session: ${e.message}")
            null
        }
    }

    fun clearSession() {
        try {
            val storage = window.localStorage
            storage.removeItem(KEY_USER)
            storage.removeItem(KEY_ACCESS)
            storage.removeItem(KEY_REFRESH)
            storage.removeItem(KEY_CREATED_AT)
            println("JsSessionStorage: Session cleared")
        } catch (e: Exception) {
            println("JsSessionStorage: Failed to clear session: ${e.message}")
        }
    }

    fun hasSession(): Boolean {
        return try {
            window.localStorage.getItem(KEY_USER) != null &&
                window.localStorage.getItem(KEY_ACCESS) != null
        } catch (e: Exception) {
            false
        }
    }
}
